import { QUERY_KEY } from '@/const/key-stores';
import { Flow } from '../types/flow';
import { useQState } from '@/hooks/useQState';

export const useFlow = () => {
  const [flow, setFlow] = useQState<Flow>(QUERY_KEY.flow, 'top');
  return { flow, setFlow };
};
